<template>
    <div>
        <Editor
            v-if="mounted"
            v-model="localValue"
            license-key="gpl"
            :disabled="disabled"
            :init="{
                setup: initEditor,
                licenseKey: 'gpl',
                height: 400,
                convert_urls: false,
                content_style: '.mce-content-body {font-size:14px;font-family:Avenir, Helvetica, sans-serif;}',
                promotion: false,
                plugins: 'code image',
                link_default_target: '_blank',
                link_target_list: [
                    { text: 'New window', value: '_blank' }
                ]
            }"
            :toolbar="[mergeFields.length > 0 ? 'mergeFields' : '', 'bold italic forecolor backcolor undo redo formatselect bullist numlist code']"
            @input="change"
        />
    </div>
</template>

<script setup>
    import Editor from '@tinymce/tinymce-vue';
    import { ref, watch, onMounted, defineProps, defineEmits, onBeforeUnmount } from 'vue';

    const emit = defineEmits(['input', 'change']);
    const props = defineProps({
        value: {
            type: String | null,
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        mergeFields: {
            type: Array,
            default: () => [],
        },
    });

    const mounted = ref(false);
    const localValue = ref(props.value);
    const editorInstance = ref(null);

    watch(() => props.value, (newValue) => {
        localValue.value = newValue;
    });

    onMounted(() => {
        mounted.value = true;
    });

    onBeforeUnmount(() => {
        mounted.value = false;

        if (editorInstance.value) {
            editorInstance.value.remove();
            editorInstance.value = null;
        }
    });

    function initEditor(editor) {
        editorInstance.value = editor;

        editor.ui.registry.addMenuButton('mergeFields', {
            text: 'Mergevelden',
            fetch(callback) {
                callback(props.mergeFields.map(mergeField => {
                    return {
                        type: 'menuitem',
                        text: `[[${mergeField.name}]] ${mergeField.required ? '*' : ''}`,
                        onAction() {
                            editor.insertContent(`[[${mergeField.name}]]`);
                        },
                    };
                }));
            },
        });
    }

    function change() {
        emit('input', localValue.value);
        emit('change', localValue.value);
    }
</script>

<style lang="scss">
    .tox-tinymce {
        border-radius: 0.2rem;

        &.tox-tinymce--disabled {
            .tox-edit-area__iframe {
                background-color: #EFF2F7;
                opacity: 0.7;
            }
        }
    }

    .tox-statusbar__branding {
        display: none !important;
    }
</style>
